export default __webpack_public_path__ + "static/media/down-arrow.796fe59b.svg";